// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.pull-up[data-v-c7b09128] {\n    transition: all 0.25s ease;\n}\n.pull-up[data-v-c7b09128]:hover {\n    z-index: 2;\n    transform: translateY(-4px) scale(1.02);\n    cursor: pointer;\n}\n.miniTitle[data-v-c7b09128] {\n    font-size: 8px;\n    color: grey;\n    letter-spacing: 1px;\n    padding: 5px;\n    text-transform: uppercase;\n}\n", ""]);
// Exports
module.exports = exports;
